import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 1L8.42188 1V4.9694L0 4.9694V5.9694H3.36914L3.36914 9.98478H0V10.9848H8.42188V15.0007L0 15.0007V16.0007H16.0025V15.0007H9.42188V10.9848L16.0025 10.9848V9.98479H13.6338V5.9694L16.0025 5.9694V4.9694H9.42188V1L16.0025 1V0H0V1ZM4.36914 9.98478L12.6338 9.98479V5.9694H4.36914V9.98478Z",
		fill: "currentColor"
	})
});
export default SvgBuilding;
